
import Typography from '@mui/material/Typography'



export default function Homepage() {
  return (
    <div className='home'>
      <Typography variant='h3' >What makes up a perfect Salsa?</Typography>
      <br />
      <img className='chiles' src="https://cdn.pixabay.com/photo/2015/03/06/23/35/pepper-662550_960_720.jpg" alt=""></img>
      <br />
      <div className="home-content">
        <br />
        <Typography variant='h5'>
        Making the perfect salsa is impossible. There are endless combinations and its unique for everyone. Some enjoy the heat, some enjoy the taste, and some just
        like to be creative with it. Its all about exploring those taste buds. Everyone is different when they
        try salsa. Making a salsa that fits your taste buds is what matters. 
        </Typography>
      </div>

  
      </div>
  )
}
